import api from './api';
import { ApiResponse } from '../types';

export interface WhitelabelConfig {
  id: string;
  user_id: string;
  domain?: string;
  subdomain?: string;
  logo_url?: string;
  favicon_url?: string;
  primary_color?: string;
  company_name?: string;
  is_active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface WhitelabelBranding {
  logo_url?: string;
  favicon_url?: string;
  primary_color?: string;
  company_name?: string;
}

export interface AvailabilityCheck {
  domain_available: boolean;
  subdomain_available: boolean;
}

export const whitelabelService = {
  async getConfig(): Promise<ApiResponse<WhitelabelConfig | null>> {
    const response = await api.get('/whitelabel');
    return response.data;
  },

  async saveConfig(data: Partial<WhitelabelConfig>): Promise<ApiResponse<WhitelabelConfig>> {
    const response = await api.post('/whitelabel', data);
    return response.data;
  },

  async deleteConfig(): Promise<ApiResponse<void>> {
    const response = await api.delete('/whitelabel');
    return response.data;
  },

  async checkAvailability(domain?: string, subdomain?: string): Promise<ApiResponse<AvailabilityCheck>> {
    const response = await api.get('/whitelabel/availability', {
      params: { domain, subdomain }
    });
    return response.data;
  },

  // Public endpoint - doesn't require auth
  async checkDomain(domain: string): Promise<ApiResponse<WhitelabelBranding | null>> {
    const response = await api.get(`/whitelabel/check/${encodeURIComponent(domain)}`);
    return response.data;
  }
};
